<template>
    <div style="transform: translateY(-15px)">
        <v-list-item three-line>
            <v-list-item-content>
                <v-list-item-subtitle>
                    <v-file-input
                        v-if="!readOnly"
                        :v-model="file"
                        :label="label"
                        @change="fileChange"
                        accept="image/*"
                        :outlined="outlined"
                        hide-details
                    ></v-file-input>
                    <h3
                        v-else>
                        {{label}}
                    </h3>
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar size="54" tile>
                <v-img
                    :src="imageValue"
                ></v-img>
                <input type="hidden" :name="name" :value="imageValue" />
            </v-list-item-avatar>
        </v-list-item>
    </div>
</template>

<script>
export default {
    props: [ 'name', 'readOnly', 'label', 'value', 'outlined', 'dark', 'mainColor' ],
    name: "File",
    data(){
        return{
            file: null,
            loading: false,
            imageValue: this.value
        }
    },
    watch:{
        value(){
            this.imageValue = Buffer.from(this.value.data).toString();
        }
    },
    methods: {
        fileChange(e){
            const reader = new FileReader();
            reader.addEventListener('load', (event) => {
                const result = event.target.result;
                this.imageValue = result;
            });
            reader.readAsDataURL(e);
        }
    }
}
</script>